// extracted by mini-css-extract-plugin
module.exports = {"statsContainer":"HomeStats_statsContainer__3l4nT","stat":"HomeStats_stat__29YyD","amount":"HomeStats_amount__zH4sa","subtitle":"HomeStats_subtitle__2hK5r"};